export let ResellerHomepageColorType = /*#__PURE__*/function (ResellerHomepageColorType) {
  ResellerHomepageColorType["LIGHT"] = "light";
  ResellerHomepageColorType["DARK"] = "dark";
  return ResellerHomepageColorType;
}({});
export let ResellerHomepageButtonColorType = /*#__PURE__*/function (ResellerHomepageButtonColorType) {
  ResellerHomepageButtonColorType["PRIMARY"] = "primary";
  ResellerHomepageButtonColorType["SECONDARY"] = "secondary";
  return ResellerHomepageButtonColorType;
}({});